import { render, staticRenderFns } from "./fbaCreate.vue?vue&type=template&id=45892fb1&scoped=true"
import script from "./fbaCreate.vue?vue&type=script&lang=js"
export * from "./fbaCreate.vue?vue&type=script&lang=js"
import style0 from "./fbaCreate.vue?vue&type=style&index=0&id=45892fb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45892fb1",
  null
  
)

export default component.exports